// src/utils/currencyConverter.js

import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import { API_URL, API_KEY } from '../../../../config/CurrencyConfig';

export const convertCurrency = async (baseCurrency, targetCurrency, currencyList, IsAuto) => {
    const redirectCallback = () => { }; // Define a no-op redirect function if needed
    const baseCurrencyCode = await CurrencyService.CurrenyBySymbol(redirectCallback, baseCurrency);
    const targetCurrencyCode = await CurrencyService.CurrenyBySymbol(redirectCallback, targetCurrency);
    
    if (IsAuto === "1") {
        try {
            const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
            const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${baseCurrencyCode[0].vc_CurrencyCode}`;

            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseData = await response.json();
            if (responseData.data) {
                const exchangeRates = responseData.data;
                if (exchangeRates[targetCurrencyCode[0].vc_CurrencyCode]) {
                    const exchangeRate = exchangeRates[targetCurrencyCode[0].vc_CurrencyCode];
                    return exchangeRate; // Return converted amount
                } else {
                    throw new Error(`Exchange rate for ${targetCurrencyCode} not found.`);
                }
            } else {
                throw new Error('Invalid response data.');
            }
        } catch (error) {
            throw new Error(`Error fetching currency data: ${error.message}`);
        }
    } else {
        const convertedManualPrice = targetCurrencyCode[0].dec_CurrencyToBaseRate ;
        return parseFloat(convertedManualPrice).toFixed(2); // Return converted manual price
    }
};
